import { BillingItem, BillingItemType } from '@monolith/legacy/types/billing-item';

export enum KeyName {
  BILLING_ITEM_TYPE = 'billing_item_type',
  TYPE = 'type',
}

export const isBillingItemShippingFee = (billingItem: BillingItem, key: KeyName = KeyName.BILLING_ITEM_TYPE): boolean => {
  const shippingTypes = [
    BillingItemType.shippingFees,
    BillingItemType.retailerShippingFees,
    BillingItemType.shippingFeesDiscount,
  ];
  return shippingTypes.includes(billingItem[key]);
};
